(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sohot-faq-costume"] && !Shopify.designMode) return;
  try {
    
(function() {
  function isMobile() { return window.innerWidth < 750; }

  function initFAQ() {
    var items = document.querySelectorAll('[data-faq-item]');
    if (!items.length) return;

    items.forEach(function(item) {
      var btn    = item.querySelector('.shc-faq__question');
      if (!btn) return;

      btn.addEventListener('click', function() {
        if (!isMobile()) return;
        var isOpen = item.classList.contains('is-open');

        // Close all
        items.forEach(function(other) {
          other.classList.remove('is-open');
          var ob = other.querySelector('.shc-faq__question');
          if (ob) ob.setAttribute('aria-expanded', 'false');
        });

        // Toggle this one
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQ);
  } else {
    initFAQ();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sohot-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  function isMobile() { return window.innerWidth < 750; }

  function initFAQ() {
    var items = document.querySelectorAll('[data-faq-item]');
    if (!items.length) return;

    items.forEach(function(item) {
      var btn    = item.querySelector('.shc-faq__question');
      if (!btn) return;

      btn.addEventListener('click', function() {
        if (!isMobile()) return;
        var isOpen = item.classList.contains('is-open');

        // Close all
        items.forEach(function(other) {
          other.classList.remove('is-open');
          var ob = other.querySelector('.shc-faq__question');
          if (ob) ob.setAttribute('aria-expanded', 'false');
        });

        // Toggle this one
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQ);
  } else {
    initFAQ();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
